import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "href", "iconEnd", "tokens", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './LinkHighlighted.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var BaseLinkHighlighted = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var title = _ref.title,
      href = _ref.href,
      IconEnd = _ref.iconEnd,
      tokens = _ref.tokens,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsxs(views.Wrapper, _objectSpread(_objectSpread({
    role: "menuitem",
    href: href,
    onClick: onClick
  }, tokens), {}, {
    children: [_jsx(views.Link, _objectSpread(_objectSpread(_objectSpread({
      variant: "pSmallBold",
      ref: ref
    }, tokens.link), rest), {}, {
      children: title
    })), _jsx(views.Icon, _objectSpread(_objectSpread({}, tokens.link), {}, {
      children: IconEnd && _jsx(IconEnd, {
        size: "small"
      })
    }))]
  }));
});
var LinkHighlighted = withDesignTokens(BaseLinkHighlighted, function (_props, theme) {
  return {
    link: {
      color: theme.palette.twilio.gray[100]
    },
    hoverColor: theme.palette.twilio.blue[60],
    activeColor: theme.palette.twilio.blue[60]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
export default LinkHighlighted;